import { render, staticRenderFns } from "./gettingStartedHomePageCard.vue?vue&type=template&id=16be399c&scoped=true&"
import script from "./gettingStartedHomePageCard.vue?vue&type=script&lang=js&"
export * from "./gettingStartedHomePageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be399c",
  null
  
)

export default component.exports